module.exports = __webpack_public_path__ + "img/dateEle.0d6b6aab.svg";